import { faPrint } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@mantine/core'
import { useLocalStorage } from '@mantine/hooks'
import lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { Menu } from 'semantic-ui-react'
import styled from 'styled-components'

import { Col, Row } from '../../../1stlog-ui/src/components/Bootstrap'
import Dialog, { useDialog } from '../../../1stlog-ui/src/components/Dialog'
import Icon from '../../../1stlog-ui/src/components/Icon'
// import { useLocalStorage } from '../../../1stlog-ui/src/hooks'
import { useUserModules } from '../UserModules'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const Position = styled(Col)`
  background-color: #f1f5f7;
  min-height: 300px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: ${({ active }) =>
    active ? `2px solid #4fc6e1` : '2px solid transparent'};
  margin: 1px;
  &:hover {
    cursor: pointer;
    border: ${({ active }) =>
      active ? `2px solid #91ebff` : '2px solid #4fc6e1'};
  }
  box-shadow: ${({ active }) =>
    active
      ? `0 0
    5px #4fc6e1`
      : 'none'};
  z-index: ${({ active }) => (active ? 2 : 1)};
`

const PrintFormatSelect = (props) => {
  const {
    labelToken,
    openOnMount,
    back = lodash.noop,
    url,
    text = i18n.t('print_label', 'Label drucken'),
    orderIds,
    onPopupBlocked = lodash.noop,
  } = props

  const userModules = useUserModules()

  const isLabelGroupAllowed = true // userModules.includes("print_format_labelgroup")

  const [format, setFormat] = useLocalStorage({
    key: 'printFormat',
    defaultValue: {
      format: 'label',
    },
    getInitialValueInEffect: false,
  })

  const [position, setPosition] = useLocalStorage({
    key: 'printFormatPosition',
    defaultValue: 0,
    getInitialValueInEffect: false,
  })

  const [isLoading, setIsLoading] = useState(false)

  const dialog = useDialog()

  useEffect(() => {
    if (orderIds) {
      return
    }
    if (!openOnMount) {
      return
    }
    if (!labelToken) {
      // if (/localhost/.test(window.location)) {
      //   return
      // }
      back()
    } else {
      // timeout = setTimeout(() => {
      //   try {
      //     submit()
      //   } catch (err) {}
      // }, 100)
      submit()
    }

    // return () => {
    //   try {
    //     clearTimeout(timeout)
    //   } catch (err) {}
    // }
  }, [])

  const changeFormat = (value) => {
    setFormat({ format: value })
  }

  const submit = async () => {
    if (orderIds) {
      const massUrl = `${url || '/api/order/label/mass'}?format=${lodash.get(
        format,
        'format',
      )}${format.format === 'labelgroup' ? `&position=${position}` : ''}`
      const form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('target', '_blank')
      form.setAttribute('action', massUrl)
      const orderIdsField = document.createElement('input')
      orderIdsField.setAttribute('type', 'hidden')
      orderIdsField.setAttribute('name', 'data')
      orderIdsField.setAttribute('value', JSON.stringify(orderIds))
      form.appendChild(orderIdsField)
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
      dialog.close()

      return
      // try {
      //   setIsLoading(true)
      //   const massUrl = `${url || "/api/order/label/mass"}?format=${lodash.get(
      //     format,
      //     "format"
      //   )}${format.format === "labelgroup" ? `&position=${position}` : ""}`
      //   const result = await requestMassPrint(massUrl, orderIds)
      //   toast.success("Labels wurden an den Drucker gesendet.")
      //   dialog.close()
      // } catch (err) {
      //   console.error("failed to mass print", err)
      //   toast.error("Fehler beim Drucken der Labels")
      // } finally {
      //   setIsLoading(false)
      // }
      // return
    }
    const labelUrl = `${
      url || '/api/order/label/'
    }${labelToken}?format=${lodash.get(format, 'format')}${
      format.format === 'labelgroup' ? `&position=${position}` : ''
    }`
    const labelTab = window.open(labelUrl)

    if (!labelTab || labelTab.closed || typeof labelTab.closed == 'undefined') {
      onPopupBlocked()
    }
    dialog.close()
    return

    // const a = document.createElement("a")
    // a.href = `${url || "/api/order/label/"}${labelToken}?format=${lodash.get(
    //   format,
    //   "format"
    // )}${format.format === "labelgroup" ? `&position=${position}` : ""}`
    // a.target = "_blank"
    // document.body.appendChild(a)
    // a.click()
    // document.body.removeChild(a)
    // dialog.close()
  }

  return (
    <>
      <Dialog
        {...dialog}
        isLoading={isLoading}
        title={text}
        onSubmit={submit}
        submitButton={
          <Button primary icon="far fa-external-link-alt">
            {orderIds
              ? i18n.t('print_labels', 'Labels drucken')
              : i18n.t('open_label', 'Label öffnen')}
          </Button>
        }
        closeButton={i18n.t('cancel', 'Abbrechen')}
      >
        <div className="">
          <h5 className="my-2 text-center">
            {lodash.isEmpty(orderIds)
              ? i18n.t('how_print_order', 'Wie möchten Sie das Label drucken?')
              : i18n.t('how_print_orders', {
                  defaultValue:
                    'Wie möchten Sie die Labels der {{orderCount}} Sendungen drucken?',
                  orderCount: lodash.size(orderIds),
                })}
          </h5>
        </div>
        <div className="d-flex justify-content-center">
          <Menu compact icon="labeled">
            <Menu.Item
              active={format.format === 'A4'}
              onClick={() => changeFormat('A4')}
            >
              <Icon size={1.2} icon="far fa-file" className="mb-1" />
              DIN-A4
            </Menu.Item>

            <Menu.Item
              active={format.format === 'label'}
              onClick={() => changeFormat('label')}
            >
              <Icon size={1.2} icon="far fa-image" className="mb-1" />
              {i18n.t('label', 'Label')}
            </Menu.Item>

            {isLabelGroupAllowed && (
              <Menu.Item
                active={format.format === 'labelgroup'}
                onClick={() => changeFormat('labelgroup')}
              >
                <Icon
                  size={1.2}
                  icon="far fa-game-board-alt"
                  className="mb-1"
                />
                {i18n.t('label_group', 'Labelgruppe')}
              </Menu.Item>
            )}
          </Menu>
        </div>
        {format.format === 'labelgroup' && (
          <div className="mx-2 mt-2 mb-0">
            <div className="mb-1 text-center">
              {i18n.t(
                `choose_label_print_start`,
                `Wählen sie eine Startposition für den Labeldrucker`,
              )}
              :
            </div>
            {lodash.map(
              lodash.chunk(Array.from(Array(4).keys()), 2),
              (chunk) => {
                return (
                  <Row>
                    {lodash.map(chunk, (index) => (
                      <Position
                        onClick={() => setPosition(index)}
                        active={position === index}
                        className=" text-center"
                        style={{ fontSize: '2rem' }}
                      >
                        <span className="mx-auto my-auto text-dark">
                          {index + 1}
                        </span>
                      </Position>
                    ))}
                  </Row>
                )
              },
            )}
          </div>
        )}
      </Dialog>
      <Button
        // variant="light"
        color="blue"
        onClick={dialog.open}
        leftIcon={<FontAwesomeIcon icon={faPrint} />}
      >
        {text}
      </Button>
    </>
  )
}

export default PrintFormatSelect
